import { path as notificationPath } from "../notifications/path";

import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

export const CreateNotificationRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.createNotification.route,
      lazy: () => import("@pages/panelPages/newNotification/newNotification"),
      loader: ({ request }) => {
        useUIStore.getState().setPage(
          request,
          "pageTitle.newNotif",
          [
            {
              title: "pageTitle.notifDetail",
              url: notificationPath.notifications.link(),
            },
          ],
          "index",
        );
        return {};
      },
    },
    permissions: [
      "admin",
      "super-admin",
      "local-admin",
      "staff",
      "doctor",
      "medical-service-provider-drug",
      "medical-service-provider-lab",
      "medical-service-provider-image",
    ],
  },
];
